import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import React, { useState, useEffect, useRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { currentDate } from "utils/formatDate";


export const TableKyLai = ({
  dataLanDongLai,
  UpdateThanhToan,
  dataSearchLanDongLai,
  PhanTrang,
  NguoiNhan,
  nhanvayId,
  setHidePopupTraLai,
  printThuChi
}) => {
  const [checked, setchecked] = useState(false);
  // Chặn double click gọi 2 lần trước khi list load lại xong: ref chặn ngay lập tức,
  // state để disable checkbox đang xử lý (mỗi ObtainPaidId xử lý độc lập).
  const processingRef = useRef(new Set());
  const [processingIds, setProcessingIds] = useState(new Set());
  const togglechecked = (isThanhToan, item, thuchiId) => {
    const key = "ob_" + item.ObtainPaidId;
    if (processingRef.current.has(key)) return;
    processingRef.current.add(key);
    setProcessingIds(new Set(processingRef.current));

    Promise.resolve(
      UpdateThanhToan(
        isThanhToan,
        item.NhanVayId,
        currentDate(),
        NguoiNhan,
        item.SoTienThanhToan,
        item.PhiKhac,
        item.PhiKho,
        "",
        parseFloat(thuchiId)
      )
    ).finally(() => {
      processingRef.current.delete(key);
      setProcessingIds(new Set(processingRef.current));
    });
  };
  const XoaThanhToan = (isThanhToan, thuchiId) => {
    const key = "chi_" + thuchiId;
    if (processingRef.current.has(key)) return;
    processingRef.current.add(key);
    setProcessingIds(new Set(processingRef.current));

    Promise.resolve(
      UpdateThanhToan(
        isThanhToan,
        nhanvayId,
        currentDate(),
        NguoiNhan,
        0,
        0,
        0,
        "",
        thuchiId
      )
    ).finally(() => {
      processingRef.current.delete(key);
      setProcessingIds(new Set(processingRef.current));
    });
  };

  const cacLanDong = (itemCV, chophepxoa, ObtainPaidId, PaidMaxID) => {
    return itemCV.CacLanDong.map((item, index) => {
      let thuchiId = item.ThuChiID;
      let showDelete = ObtainPaidId === PaidMaxID && chophepxoa;
      return (
        <>
          <div className=" d-flex form-mobile-donglai">
            <p class="text-center">
              <a
                href={() => false}
                onClick={(e) => printThuChi(itemCV, item.ThuChiID)}
              >
                {formatNumber(item.TienThanhToan * -1)}
              </a>

              <span class="date-sm">({item.ThoiGianThanhToan})</span>
            </p>

            {showDelete && (
              <>
                <button
                  className="btn-donglai-xoa"
                  disabled={processingIds.has("chi_" + thuchiId)}
                  onClick={(e) => XoaThanhToan(0, thuchiId)}
                >
                  <PopoversBootrap
                    contentText="Xoá"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i class="fas fa-trash"></i>
                  </PopoversBootrap>
                </button>
              </>
            )}
            {!showDelete && <span> </span>}
          </div>
        </>
      );
    });
  };

  //show hide lần đóng lại trên mobile
  let isShow = true;
  let displayText = "contents";
  if (matchMedia) {
    var mq = window.matchMedia("(max-width: 768px)");
    isShow = !mq.matches;
    if (mq.matches) displayText = "block";
  }
  const itemShowinit = {
    item: null,
    isShow: isShow,
    displayText,
  };
  const [dataShowItem, SetDataShowItem] = useState(itemShowinit);

  const showRow = (item) => () => {
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !dataShowItem.isShow;
    }
    dataShowItem.item = item;
    dataShowItem.isShow = isShow;
    SetDataShowItem({
      ...dataShowItem,
      item: item,
      isShow: isShow,
      displayText,
    });
  };
  //End-show hide lần đóng lại trên mobile
  const listItem = () => {
    return (
      dataLanDongLai.List != null &&
      dataLanDongLai.List.map((item, index) => {
        let chophepxoa = dataLanDongLai.PaidMaxID === item.ObtainPaidId;
        let thuchiId = item.CacLanDong.map((item) => item.ThuChiID);
        return (
          <>
            <div class="custom-table-row">
              <div class="custom-table-cell username-cell flex-basis-5 disk-mobile">
                <span class="mobile-column-name">STT</span>
                <div class="center-wrapper">
                  <p class="text-center">
                    {index + 1 + (dataSearchLanDongLai.pageIndex - 1) * 5}
                  </p>
                </div>
              </div>

              <div class="row-show-three">
                <div
                  class="row-mobile"
                  style={{
                    display:
                      dataShowItem.isShow &&
                      (!dataShowItem.item || dataShowItem.item === item)
                        ? "none"
                        : dataShowItem.displayText,
                  }}
                >
                  <div class="custom-table-cell flex-basis-6 flex-basis-6-responsive">
                    <span class="mobile-column-name disk-mobile">
                      Ngày trả lãi
                    </span>
                    <div class="center-wrapper">
                      <p class="icon-dropdown-mobile" onClick={showRow(item)}>
                        <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                        {item.NgayTraLai}
                      </p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-11 flex-basis-13-sm flex-disk">
                    <span class="mobile-column-name disk-mobile">
                      Cần thanh toán
                    </span>
                    <div class="center-wrapper">
                      <p class="text-left">
                        {formatNumber(item.TienLai + item.TienGoc)}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="form-row-detail content12"
                  style={{
                    display:
                      dataShowItem.isShow &&
                      (!dataShowItem.item || dataShowItem.item === item)
                        ? dataShowItem.displayText
                        : "none",
                  }}
                >
                  <div class="custom-table-cell flex-basis-6 flex-basis-6-responsive">
                    <span class="mobile-column-name disk-mobile">
                      Ngày trả lãi
                    </span>
                    <div class="center-wrapper">
                      <p class="icon-dropdown-mobile" onClick={showRow(item)}>
                        <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                        {item.NgayTraLai}
                      </p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-11 flex-basis-13-sm flex-disk">
                    <span class="mobile-column-name disk-mobile">Tiền lãi</span>
                    <div class="center-wrapper">
                      <p class="text-right">{formatNumber(item.TienLai)}</p>
                    </div>
                  </div>
                  <div class="custom-table-cell flex-basis-11 flex-basis-13-sm">
                    <span class="mobile-column-name">Tiền gốc</span>
                    <div class="center-wrapper">
                      <p class="text-right">{formatNumber(item.TienGoc)}</p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-10 flex-basis-10-responsive">
                    <span class="mobile-column-name">Phí khác</span>
                    <div class="center-wrapper">
                      <p class="text-right">{formatNumber(item.PhiKhac)}</p>
                    </div>
                  </div>
                  <div class="custom-table-cell flex-basis-11 flex-basis-13-sm">
                    <span class="mobile-column-name">Số tiền đã trả</span>
                    <div class="center-wrapper">
                      <p class="text-right">{formatNumber(item.DaThanhToan)}</p>
                    </div>
                  </div>

                  <div class="custom-table-cell flex-basis-15 flex-basis-13-sm">
                    <span class="mobile-column-name">Các lần đóng</span>
                    <div class="center-wrapper btn-link">
                      {cacLanDong(
                        item,
                        chophepxoa,
                        item.ObtainPaidId,
                        dataLanDongLai.PaidMaxID
                      )}
                    </div>
                  </div>
                </div>

                <div class="custom-table-cell flex-basis-5  sticky-icon sticky-col-new first-col-new">
                  <div class="center-wrapper">
                    <div class="inputTableMorman">
                      <div class="b-checkbox is-danger">
                        {item.DaThanhToan - item.TienLai - item.TienGoc >= 0 &&
                          !chophepxoa && (
                            <input
                              id="checkbox1"
                              class="styled"
                              type="checkbox"
                              checked={true}
                              disabled={true}
                            />
                          )}
                        {item.DaThanhToan - item.TienLai - item.TienGoc >= 0 &&
                          chophepxoa && (
                            <input
                              checked={true}
                              id="checkbox1"
                              class="styled"
                              type="checkbox"
                              disabled={processingIds.has(item.ObtainPaidId)}
                              onClick={(e) => togglechecked(0, item, thuchiId)}
                            />
                          )}
                        {item.DaThanhToan - item.TienLai - item.TienGoc < 0 && (
                          <input
                            checked={false}
                            id="checkbox1"
                            class="styled"
                            type="checkbox"
                            disabled={processingIds.has(item.ObtainPaidId)}
                            onClick={(e) => togglechecked(1, item, thuchiId)}
                          />
                        )}{" "}
                        <label for="checkbox1"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })
    );
  };


  return (
    <div class="Left808x200 Table-main-new table-mobile-new">
      <div class="table-responsive table-responsive-new table-new1 ">
        <div class="custom-table-wrapper">
          <div class="table-headers">
            <div class="custom-table-header flex-basis-5">
              <p class="text-center">
                STT
                <br /> <span class="red">[ {dataLanDongLai.TongBanGhi} ]</span>
              </p>
            </div>
            <div class="custom-table-header flex-basis-6 flex-basis-6-responsive ">
              <p>Ngày trả lãi</p>
            </div>
            <div class="custom-table-header flex-basis-11 flex-basis-13-sm">
              <p class="text-right">
                Tiền lãi
                <br /> <i class="la la-dollar text-b"></i>=
                <span class="home-new-yellow">
                  {formatNumber(dataLanDongLai.TongTienLai)}
                </span>
              </p>
            </div>
            <div class="custom-table-header flex-basis-11 flex-basis-13-sm">
              <p class="text-right">
                Tiền gốc
                <br /> <i class="la la-dollar text-b"></i>=
                <span class="red">
                  {formatNumber(dataLanDongLai.TongTienGoc)}
                </span>
              </p>
            </div>
            <div class="custom-table-header flex-basis-10 flex-basis-10-responsive">
              <p class="text-right">
                Phí khác
                <br /> <i class="la la-dollar text-b"></i>=
                <span class="">{formatNumber(dataLanDongLai.TongPhiKhac)}</span>
              </p>
            </div>
            <div class="custom-table-header flex-basis-11 flex-basis-13-sm">
              <p class="text-right">
                Số tiền đã trả <br /> <i class="la la-dollar text-b"></i>=
                <span class="home-new-blue">
                  {formatNumber(dataLanDongLai.TongThanhToan)}
                </span>
              </p>
            </div>

            <div class="custom-table-header flex-basis-15 flex-basis-13-sm">
              <p class="tab-header text-center">Các lần đóng</p>
            </div>
            <div class="custom-table-header flex-basis-5 sticky-col-new first-col-new">
              <p class="tab-header text-center">Thao tác</p>
            </div>
          </div>

          <div class="custom-table-body">
            <div class="custom-table-row">
              <div class="custom-table-cell username-cell-mobile flex-basis-5 disk-desktop show-mobile">
                <span class="mobile-column-name">Ngày trả lãi</span>
                <div class="center-wrapper">
                  <p class="text-center">Cần thanh toán</p>
                </div>
              </div>
            </div>
            {listItem()}
          </div>
        </div>
      </div>

    </div>
  );
};
